__turbopack_context__.v({
  "Textlink": "oqOhjW_Textlink",
  "col-legal-s": "oqOhjW_col-legal-s",
  "email-l": "oqOhjW_email-l",
  "email-m": "oqOhjW_email-m",
  "email-xl": "oqOhjW_email-xl",
  "emailError": "oqOhjW_emailError",
  "footerContainer": "oqOhjW_footerContainer",
  "formEmail": "oqOhjW_formEmail",
  "formEmailAddress": "oqOhjW_formEmailAddress",
  "formGroup": "oqOhjW_formGroup",
  "formSubmit": "oqOhjW_formSubmit",
  "label": "oqOhjW_label",
  "link": "oqOhjW_link",
  "loginBox": "oqOhjW_loginBox",
  "logoWrap": "oqOhjW_logoWrap",
  "longLink": "oqOhjW_longLink",
  "mth": "oqOhjW_mth",
  "signUpTerms": "oqOhjW_signUpTerms",
  "styledLinks": "oqOhjW_styledLinks",
  "styledMobileLinks": "oqOhjW_styledMobileLinks",
  "styledSocial": "oqOhjW_styledSocial",
  "tabletEmailForm": "oqOhjW_tabletEmailForm",
});
